module.exports = __webpack_public_path__ + "img/16581265_L.530f5b11.png";